import { render, staticRenderFns } from "./management-organization-list.vue?vue&type=template&id=a4a776e2&"
import script from "./management-organization-list.vue?vue&type=script&lang=js&"
export * from "./management-organization-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports